import React from "react";
import {
  Box,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
  Stack,
} from "@mui/material";

const features = [
  {
    icon: "💡",
    title: "All In One Solution",
    description:
      "You will get a complete business communication solution with Vertex Suite, don’t need to spend more for other softwares",
  },
  {
    icon: "😊",
    title: "Trusted Globally by Thousands",
    description:
      "Start your business journey with confidence. 2000+ customers in 80+ countries trust Vertex Suite as their modern communication partner",
  },
  {
    icon: "🤝",
    title: "Facebook (Meta) & Google Partner",
    description:
      "Direct Integration with WhatsApp, Facebook & Instagram. Vertex Suite is an authorized Facebook (Meta) & Google Partner.",
  },
  {
    icon: "🎧",
    title: "Guided Support and Tutorials",
    description:
      "We help you to onboard and get started without asking any extra charges for the first few sessions. Refer to our step-by-step tutorials.",
  },
  {
    icon: "👍",
    title: "We Build What You Need?",
    description:
      "We don’t build products simply because others are building; we build products and features when we see a gap.",
  },
  {
    icon: "👨‍💻",
    title: "24/7 Friendly Human Support",
    description:
      "Our friendly support team via Email (24 x 7) & Live Chat always available to assist when you land in trouble.",
  },
];

const ChooseSection = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        padding: "20px",
        my: 4,
      }}
    >
      <Box
        sx={{
          padding: "20px",
          textAlign: "center",
          backgroundColor: "#f5f7fa",
          width: { xl: "74%", lg: "96%", md: "80%", sm: "100%", xs: "100%" },
          // marginTop: "12px"
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom
          sx={{
            marginTop: "12px"
          }}
        >
          Why Choose Vertex Suite?
        </Typography>
        <Typography
          sx=
          {{
            marginBottom: "20px",
            color: "#333",
            fontSize: { xl: "18px", lg: "18px", md: "16px", sm: "16px", xs: "16px" },
            textAlign: "justify",
            ml: {xs: "0", md: "8%"}
            }}
        >
          We know there are competitors in the market and winning the customer’s
          heart is possible only by answering “Why Vertex Suite?” below are the
          answers for you,
        </Typography>

        <Grid
          container
          spacing={isXs ? 1 : isSm ? 2 : 4}
          justifyContent="center"
          sx={{ width: "100%", maxWidth: "1200px", margin: "auto" }}
        >
          {features.map((feature, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              sx={{
                display: "flex",
                flexDirection: isXs || isSm ? "row" : "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: isXs || isSm ? "justify" : "left",
                padding: "10px",
                // border: "1px solid blue",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: isXs || isSm ? "0" : "15px",
                  marginRight: isXs || isSm ? "15px" : "0",
                  fontSize: { xl: "60px", lg: "60px", md: "40px", sm: "48px", xs: "35px" },
                  // border: "1px solid red",
                }}
              >
                {feature.icon}
              </Box>
              <Box >
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  gutterBottom>
                  {feature.title}
                </Typography>

                <Typography
                  variant="body2"
                  color="#333"
                  sx={{
                    fontSize: {
                      xl: "16px",
                      lg: "16px",
                      md: "16px",
                      sm: "16px",
                      xs: "15px",
                    },
                  }}
                >
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Stack>
  );
};

export default ChooseSection;
